export default {"src":"/_next/static/media/chevron_left.66b19ac8.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};